import { Typography, Button, Container } from '@material-ui/core'

import { ThemeColors } from '../Theme'

export function WelcomePage(props) {

    return (
            
        <Container style={{paddingTop: 100}}>
            <Typography variant="h4" style={{textAlign: 'center', paddingBottom: 10}}>Welcome to the Membership Web Portal</Typography>
            <Typography variant="h5" style={{textAlign: 'center', paddingBottom: 10}}>Please login to manage your facility</Typography>

            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 20, marginTop: 20}}>
                <Button onClick={() => props.loginFunc("cognito")} variant='contained' style={{color: 'white', width: 300, backgroundColor: ThemeColors.appBarBackground}}>Login</Button>
            </div>

            <Typography variant="body1" style={{textAlign: 'center', fontWeight: 'bold', marginTop: 60}}>
                Forgot your password or trouble logging in?
            </Typography>
             <Typography variant="body1" style={{textAlign: 'center', marginTop: 5}}>
                <a href="https://accounts.accessgrantedsystems.net/loginHelp" style={{color: ThemeColors.linkColor, textDecoration: 'none'}}>Click here for help</a>
            </Typography>
        </Container>
    
    );
     
    
}



